import createAction from 'redux-actions/es/createAction'

export const fetch = createAction('DASHBOARD/EVENTS_RATE/FETCH')
export const receive = createAction('DASHBOARD/EVENTS_RATE/RECEIVE')
export const startPoll = createAction('DASHBOARD/EVENTS_RATE/START_POLL')
export const stopPoll = createAction('DASHBOARD/EVENTS_RATE/STOP_POLL')
